"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenInlineEditText = void 0;
const React = __importStar(require("react"));
const koden_koden_text_field_1 = require("@scott/koden.koden-text-field");
const fc_1 = require("react-icons/fc");
const vsc_1 = require("react-icons/vsc");
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Popper_1 = __importDefault(require("@mui/material/Popper"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const ButtonIcon = (0, styled_components_1.default)(material_1.Icon) `
	cursor: pointer;
`;
const KodenInlineEditText = (_a) => {
    var { defaultValue, onConfirm } = _a, props = __rest(_a, ["defaultValue", "onConfirm"]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const ref = React.useRef(defaultValue);
    const inputRef = React.useRef();
    const open = Boolean(anchorEl);
    const id = open ? `${props.id}-transitions-popper` : undefined;
    const onOk = () => {
        onConfirm(ref.current);
        setAnchorEl(null);
    };
    const onCancel = () => {
        ref.current = defaultValue;
        if (inputRef && inputRef.current) {
            // @ts-ignore
            inputRef.current.value = defaultValue;
        }
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(material_1.ClickAwayListener, { onClickAway: () => {
                    onCancel();
                } },
                React.createElement("div", { onClick: (event) => {
                        if (anchorEl === null) {
                            setAnchorEl(event.currentTarget);
                        }
                    } },
                    React.createElement(koden_koden_text_field_1.KodenTextField, Object.assign({}, props, { inputRef: inputRef, disabled: false, autoFocus: open, defaultValue: defaultValue, onChange: (value) => {
                            ref.current = value;
                        } }))))),
        React.createElement(Popper_1.default, { id: id, open: open, anchorEl: anchorEl, transition: true, placement: "bottom-end" }, ({ TransitionProps }) => (React.createElement(Fade_1.default, Object.assign({}, TransitionProps),
            React.createElement("div", { style: {
                    marginTop: 6,
                    display: "flex",
                    justifyContent: "flex-end",
                } },
                React.createElement(ButtonIcon, { style: { marginRight: 6 }, onClick: (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onOk();
                    } },
                    React.createElement(fc_1.FcCheckmark, null)),
                React.createElement(ButtonIcon, { onClick: (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onCancel();
                    } },
                    React.createElement(vsc_1.VscError, { style: { color: "red" } }))))))));
};
exports.KodenInlineEditText = KodenInlineEditText;
exports.default = exports.KodenInlineEditText;
//# sourceMappingURL=koden-inline-edit-text.js.map